export const BILLING_STATUS_LABELS = {
  draft: "Draft",
  published: "Terbit",
  sent: "Terkirim",
  paid: "Lunas",
  overdue: "Jatuh Tempo",
  cancelled: "Batal",
};

export const BILLING_STATUS_STYLES = {
  draft: "bg-secondary text-muted-foreground border-border",
  published: "bg-sky-100 text-sky-700 border-sky-200",
  sent: "bg-indigo-100 text-indigo-700 border-indigo-200",
  paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  overdue: "bg-rose-100 text-rose-700 border-rose-200",
  cancelled: "bg-secondary text-muted-foreground border-border line-through",
};

export const DELIVERY_LABELS = {
  not_sent: "Belum dikirim",
  sending: "Mengirim",
  sent: "Terkirim",
  failed: "Gagal",
};

export const MONTHS_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const UNIT_OPTIONS = ["kWh", "m³", "liter", "galon", "orang", "hari", "kg", "unit"];

export const ITEM_TYPE_LABELS = {
  fixed: "Nominal tetap",
  metered: "Per pemakaian (meteran)",
  quantity: "Per jumlah",
};

// Client-side mirror of backend _compute_item_amount (for live preview only).
export function computeItemAmount(it) {
  const t = it.type || "fixed";
  if (t === "metered") {
    if (it.meter_start === "" || it.meter_start == null || it.meter_end === "" || it.meter_end == null) return 0;
    return Math.round((Number(it.meter_end) - Number(it.meter_start)) * (Number(it.price_per_unit) || 0));
  }
  if (t === "quantity") return Math.round((Number(it.quantity) || 0) * (Number(it.price_per_unit) || 0));
  return Math.round(Number(it.amount) || 0);
}

export function formatRupiah(n) {
  const v = Number(n || 0);
  return "Rp" + Math.round(v).toLocaleString("id-ID");
}

export function formatDateID(iso) {
  if (!iso) return "-";
  try {
    const [y, m, d] = String(iso).slice(0, 10).split("-");
    return `${parseInt(d)} ${MONTHS_ID[parseInt(m) - 1]} ${y}`;
  } catch {
    return iso;
  }
}
